import * as actions from '../actions/premiumSettings';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import { PS_TYPE_PERCENTAGE } from '../helpers/constants';

export function patchPremiumSetting(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_PATCH_PREMIUM_SETTING)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings' + (action.payload.premiumSettingTypePercentage ? '/Percentage/' : '/Settings/') + +action.payload.id,
            category: 'patchPremiumSetting',
            method: 'PATCH',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('patchPremiumSetting')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePatchResponsePremiumSetting(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponsePatchPremiumSetting(sources) {
    let httpResponse$ = sources.HTTP
        .select('patchPremiumSetting')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receiveBadRequestPachPremiumSetting(response));

    return {
        ACTION: httpResponse$
    };
}

export function postNewPremiumSetting(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_POST_NEW_PREMIUM_SETTING)
        .map(action => ({
            url: BASE_URL + `api/PremiumSettings/Settings`,
            category: 'postNewPremiumSetting',
            method: 'POST',
            send: action.payload,
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('postNewPremiumSetting')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 201)
        .map(response => actions.receivePostResponseNewPremiumSetting(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponsePostNewPremiumSetting(sources) {
    let httpResponse$ = sources.HTTP
        .select('postNewPremiumSetting')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 201)
        .map(response => actions.receiveBadRequestPostNewPremiumSetting(response.response.body.message));

    return {
        ACTION: httpResponse$
    };
}

export function getPremiumSettingsDamages(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_PREMIUM_SETTINGS_DAMAGES)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings/Damages',
            category: 'getPremiumSettingsDamages',
            method: 'GET',
            withCredentials: true
        }));


    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingsDamages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsDamages(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedRequestPremiumSettingsDamages(sources) {
    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingsDamages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status >399)
        .map(response => actions.failedToGetPremiumSettingsDamages(response));

    return {
        ACTION: httpResponse$
    };
}

export function getPremiumSettingsStages(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_PREMIUM_SETTINGS_STAGES)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings/Stages',
            category: 'getPremiumSettingsStages',
            method: 'GET',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingsStages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsStages(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function badResponseGetPremiumSettingsStages(sources) {
    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingsStages')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetPremiumSettingsStages(response));

    return {
        ACTION: httpResponse$
    };
}

export function getAllPremiumSettings(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_ALL_PREMIUM_SETTINGS)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings/Settings',
            category: 'getAllPremiumSettings',
            method: 'GET',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http get requests, it updates the redux store with the lawsys agents
    let httpResponse$ = sources.HTTP
        .select('getAllPremiumSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivedAllPremiumSettings(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedGetAllPremiumSettins(sources) {
    let httpResponse$ = sources.HTTP
        .select('getAllPremiumSettings')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receivedBadRequestAllPremiumSettings(response));

    return {
        ACTION: httpResponse$
    }
}

export function getAllPremiumSettingsForSol(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE)
        .map(action => ({
            url:  action.payload.workSourceId !== null? BASE_URL + 'api/PremiumSettings/Settings/Groups/' + action.payload.solGroupId + '/' + action.payload.workSourceId:BASE_URL + 'api/PremiumSettings/Settings/Groups/' + action.payload.solGroupId + '/-1'   ,
            category: 'getAllPremiumSettingsForSol',
            method: 'GET',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http get requests, it updates the redux store with the lawsys agents
    let httpResponse$ = sources.HTTP
        .select('getAllPremiumSettingsForSol')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivedAllPremiumSettingsForSolGroup(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedGetAllPremiumSettinsForSol(sources) {
    let httpResponse$ = sources.HTTP
        .select('getAllPremiumSettingsForSol')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.receivedBadRequestAllPremiumSettingsForSolGroup(response));

    return {
        ACTION: httpResponse$
    }
}

//-----------------------------DELETE PREMIUM SETTING------------------------------------

export function deletePremiumSetting(sources) {

	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_DELETE_PREMIUM_SETTING)
		.map(action => ({
			url: BASE_URL + `api/PremiumSettings/Settings/`+action.payload.id,
			category: 'deletePremiumSetting',
			method: 'DELETE',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('deletePremiumSetting')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveDeletePremiumSetting(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badResponseDeletePremiumSetting(sources) {
	let httpResponse$ = sources.HTTP
		.select('deletePremiumSetting')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadRequestDeletePremiumSetting(response));

	return {
		ACTION: httpResponse$
	};
}

//====================CHAIN===================//
export function getPremiumSettingById(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const httpRequest$ = sources.ACTION
        .filter(action => action.type === ActionTypes.REQUEST_GET_SPECIFIC_PREMIUM_SETTING)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings/Damages'  ,
            category: 'getPremiumSettingById',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            payload: action.payload
        }));


    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingById')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingDamagesChain({
            premiumSettingId: response.request.payload.premiumSettingId,
            damages: response.body,
            isEditMode: response.request.payload.isEditMode,
            premiumSettingTypePercentage: response.request.payload.premiumSettingTypePercentage
        }));


    return {
        ACTION: httpResponse$,
        HTTP: httpRequest$
    };
}

export function getCaseTypesAfterDamages(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const httpRequest$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN)
        .map(action => ({
            url: BASE_URL + 'api/CaseTypes/CaseTypes',
            category: 'getCaseTypesAfterDamages',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            payload: action.payload
        }));

    let httpResponse$ = sources.HTTP
        .select('getCaseTypesAfterDamages')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsCaseTypesChain({
            premiumSettingId: response.request.payload.premiumSettingId,
            caseTypes: response.body,
            isEditMode: response.request.payload.isEditMode
        }));


    return {
        ACTION: httpResponse$,
        HTTP: httpRequest$
    };
}

export function getStagesAfterCaseTypes(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const httpRequest$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings/Stages',
            category: 'getStagesAfterCaseTypes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            payload: action.payload
        }));

    let httpResponse$ = sources.HTTP
        .select('getStagesAfterCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsStagesChain({
            premiumSettingId: response.request.payload.premiumSettingId,
            stages: response.body,
            isEditMode: response.request.payload.isEditMode,
            premiumSettingTypePercentage: response.request.payload.premiumSettingTypePercentage
        }));

    return {
        ACTION: httpResponse$,
        HTTP: httpRequest$
    };
}

export function getSolicitorsAfterStages(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const httpRequest$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN)
        .map(action => ({
            url: BASE_URL + 'api/users/GetLawsysAgents',
            category: 'getSolicitorsAfterStages',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            payload: action.payload
        }));

    let httpResponse$ = sources.HTTP
        .select('getSolicitorsAfterStages')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsSolicitorChain({
            premiumSettingId: response.request.payload.premiumSettingId,
            solicitors: response.body,
            isEditMode: response.request.payload.isEditMode,
            premiumSettingTypePercentage: response.request.payload.premiumSettingTypePercentage
        }));


    return {
        ACTION: httpResponse$,
        HTTP: httpRequest$
    };
}

export function getPremiumSettingAfterSolicitors(sources) {
    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const httpRequest$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings' + (action.payload.premiumSettingTypePercentage ? '/Percentage/' : '/Settings/' ) + action.payload.premiumSettingId,
            category: 'getPremiumSettingAfterSolicitors',
            method: 'GET',
            type: 'application/json',
            withCredentials: true,
            payload: action.payload
        }));

    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingAfterSolicitors')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingById({
            premiumSettings: JSON.parse(response.text),
            isEditMode: response.request.payload.isEditMode,
            //premiumSettingTypePercentage: response.request.payload.premiumSettingTypePercentage
        }));

    return {
        ACTION: httpResponse$,
        HTTP: httpRequest$
    };
}

export function receiveBadRequestGetPremiumSettingById(sources) {
    let httpResponse$ = sources.HTTP
        .select('getPremiumSettingAfterSchedules')
        .map((response) =>
            response.replaceError((err) => xs.of(err)))
        .flatten()
        .filter(response => response.status > 399 )
        .map(response => actions.receiveBadRequestPremiumSettingById(response))

    return {
        ACTION: httpResponse$
    };
}

export function getSubCaseTypeAfterGettingPremiumSetting(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.RECEIVE_PREMIUM_SETTINGS_BY_ID)
        .map(action => ({
            url: BASE_URL + 'api/CaseTypes/CaseTypes/' + action.payload.premiumSettings.caseTypeId,
            category: 'getSubCaseTypeAfterGettingPremiumSetting',
            method: 'GET',
            withCredentials: true
        }));

    //below httpResponse$ listens  for http responses and after filtering ,in order to get
    //the successful http get requests, it updates the redux store with the lawsys agents
    let httpResponse$ = sources.HTTP
        .select('getSubCaseTypeAfterGettingPremiumSetting')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsSubCasesChain(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

//===============================================//

//action that requests get premium settings with the combination of case type, solicitor
// group, sub case type and work source.
export function requestGetPremiumSettingWithCombination(sources) {
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_PREMIUM_SETTINGS_WITH_COMBINATION)
        .map(action => ({
            url: BASE_URL + 'api/PremiumSettings' + (action.payload.isTypePercentage ? '/Percentage' : '' )+ '/Cases/Groups/Current/' + action.payload.caseTypeId + '/' +
            action.payload.subCaseTypeId + '/' + action.payload.solicitorGroupId + '/' + action.payload.workSourceId,
            category: 'requestGetPremiumSettingWithCombination',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('requestGetPremiumSettingWithCombination')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receivePremiumSettingsWithCombination(JSON.parse(response.text)));

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function receiveBadResponsePremiumSettingsWithCombination(sources) {
    let httpResponse$ = sources.HTTP
        .select('requestGetPremiumSettingWithCombination')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToGetPremiumSettingsWithCombaination(response));

    return {
        ACTION: httpResponse$
    };
}

//action that requests get premium settings with the combination of case type, solicitor
// group, sub case type and work source.
export function requestGetAllPremiumSettingsWithCombination(sources) {
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION)
		.map(action => ({
			url: BASE_URL + 'api/PremiumSettings'+ (action.payload.isTypePercentage ? '/Percentage' : '' ) + '/Cases/Groups/' + action.payload.caseTypeId + '/' +
			action.payload.subCaseTypeId + '/' + action.payload.solicitorGroupId + '/' + action.payload.workSourceId,
			category: 'requestGetAllPremiumSettingsWithCombination',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('requestGetAllPremiumSettingsWithCombination')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveAllPremiumSettingsWithCombination(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadResponseAllPremiumSettingsWithCombination(sources) {
	let httpResponse$ = sources.HTTP
		.select('requestGetAllPremiumSettingsWithCombination')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.failedToGetAllPremiumSettingsWithCombaination(response));

	return {
		ACTION: httpResponse$
	};
}
